const FooterIllustrationsV2 = () => {
  return (
    <div className="hidden md:contents">
      <img
        alt="mask"
        src="/images/pages/auth-v2-mask-light.png"
        className="absolute bottom-0 -z-10 w-full dark:hidden"
      />
      <img
        alt="mask"
        src="/images/pages/auth-v2-mask-dark.png"
        className="absolute bottom-0 -z-10 hidden w-full dark:block"
      />
    </div>
  );
};

export default FooterIllustrationsV2;
